import Store from '@app/store';
import ModelHelper from '@app/helper/model';
import Config from '@app/config';

export default {
  get isAdmin() {
    const { user } = Store.getState();

    // ADMIN mode?
    const membership = ModelHelper.getMembershipFromUser(user); // TODO: create a method in this model to get membership, and get rid of the Helper
    if (
      membership.role === Config.teams.roles.ADMIN ||
      membership.role === Config.teams.roles.OWNER
    ) {
      return true;
    }
    return false;
  },
};
